import calendar from "../assets/images/mockup_all_device.png";
import {
  Box,
  Image,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  useDisclosure,
} from "@chakra-ui/react";

const MediaSection = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        p={4}
        maxW="1400px"
        mx="auto"
        position="relative"
        as="section"
        aria-label="Weboldal mockup szekció"
      >
        <Image
          src={calendar}
          sizes="(max-width: 768px) 100vw, 80vw"
          alt="Responsív megjelenés, időpontfoglaló"
          width="100%"
          height="auto"
          loading="eager"
          decoding="async"
          objectFit="contain"
          onClick={onOpen}
        />
      </Box>

      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent
          maxW="90vw"
          maxH="90vh"
          bg="transparent"
          boxShadow="none"
          position="relative"
        >
          <ModalCloseButton
            position="absolute"
            top="10px"
            right="10px"
            size="lg"
            color="white"
            bg="blackAlpha.700"
            _hover={{ bg: "blackAlpha.900" }}
          />
          <ModalBody
            p={0}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Image
              src={calendar || ""}
              alt="Responsív megjelenés, időpontfoglaló - nagyított kép"
              maxH="90vh"
              maxW="90vw"
              objectFit="contain"
              loading="lazy"
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default MediaSection;
